module.exports = __webpack_public_path__ + "img/packshot_katalog_primavera_2019.6268306a.jpg";